import React from 'react';
import * as Styled from './APrice.styles';
import { APriceSize, type APriceProps } from './APrice.types';

const COMPONENT_NAME = 'a-web-ui-kit-APrice';
const TEST_ID = 'web-ui-kit-APrice';

export const APrice: React.FC<APriceProps> = ({ value, ...rest }) => {
  return (
    <Styled.Wrapper size={APriceSize.Large} data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      {value}
    </Styled.Wrapper>
  );
};
